// DocumentUpload.jsx
import React, { useState } from 'react';
import config from '../../utils/config'; 
import { useAuth } from '../../utils/AuthContext/AuthContext'; 

const DocumentUpload = ({ onUploadSuccess, onClose, formType }) => {
  const { token } = useAuth();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // console.log("DocumentUpload", formType);

  const handleUpload = async () => {
    if (!selectedFile) return;
    setUploading(true);
    setError(null);
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('formType', formType);  // e.g., "InspectionReport"


    try {
      const response = await fetch(`${config.apiBaseUrl}/upload`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          // Do not set Content-Type manually; let the browser set it
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Upload failed');
      }
      const data = await response.json();
      setSuccessMessage('File uploaded successfully!', data.message);
      console.log("Success", data.message);
      onUploadSuccess(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
    setUploading(false);
  };

  return (
    <div className="document-upload flex-col">
      
      <input type="file" accept=".pdf,.doc,.docx" onChange={handleFileChange}/>
      
      <div className='w-full inline-flex justify-center gap-6'>
      <button 
        onClick={handleUpload} 
        disabled={uploading || !selectedFile}
        className=' bg-shi-green hover:bg-green-800 text-white text-[13px] py-1.5 px-3 rounded mt-6 '
      >
            {uploading ? 'Uploading...' : 'Upload Report'}
      </button>
      <button 
            onClick={onClose}
            className="py-1.5 px-8 rounded mt-6 text-[13px] bg-gray-300 text-gray-800 hover:bg-gray-400"
          >
            Cancel
        </button>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {successMessage && (
        <>
            <p className='text-green'>{successMessage}</p>
        </>
        )}
    </div>
  );
};

export default DocumentUpload;
